import { ValidatedTreatmentSchema } from "@redotech/redo-model/ab-tests/valid-treatments";
import { array, object, string, z } from "zod";

export const getTreatmentsSchema = {
  input: object({
    teamId: string(),
  }),
  output: array(ValidatedTreatmentSchema),
};

export type GetTreatmentsOutput = z.infer<typeof getTreatmentsSchema.output>;
